import "../styles/main.scss"
import SiteHeader from "./modules/site-header"
import SiteNavMobile from "./modules/site-nav-mobile"
import SmoothAnchor from "./modules/smooth-anchor";
import MegaMenu from "./modules/mega-menu";
import TableOfContents from "./modules/table-of-contents";
import Accordions from "./modules/accordions";
// import AOS from 'aos';

// AOS.init({
//     offset: 100,
//     duration: 600,
//     delay: 100,
//     once: true,
//     disable: function() {
//         // return window.innerWidth < maxWidth;
//     }
// });
SiteHeader().init()
SiteNavMobile().init()
SmoothAnchor().init()
MegaMenu().init()
TableOfContents().init()
Accordions().init()